// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33kJ4","delete":"styles_delete__b3Z_q","update":"styles_update__33nn7","add":"styles_add__33NMN"};